export default "__VITE_ASSET__BeB$0WKY__"